module.exports = "/_next/static/images/logo_WEB_white-be79bc54c500f17378339a1b4af168ae.svg";